import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthenticatorService {
  private days: { [key: number]: string };
  private week: { [key: number]: string };
  private months: { [key: number]: string };

  constructor() {
    this.days = {
      1: 'heLu1',
      2: '6wPja',
      3: 'SLQOb',
      4: 'uCEdx',
      5: 'uJz5O',
      6: 'jo6kk',
      7: 'JKrBd',
      8: 'TcCBj',
      9: 'xyzBh',
      10: 'iMXnB',
      11: 'lSL7Z',
      12: 'qWmdR',
      13: 'bWqOE',
      14: '73aqS',
      15: 'ztCjR',
      16: 'gljRu',
      17: 'M51li',
      18: 'Db1IU',
      19: '3UhKm',
      20: 'Dmhlk',
      21: 'KjFjC',
      22: 'CKEZ8',
      23: 'ylKnY',
      24: 'KTw3D',
      25: 'u9N7e',
      26: 'f8irj',
      27: 'sDCmK',
      28: 'UX6kF',
      29: '3GWqk',
      30: 'zexfu',
      31: 'E8rbh',
    };

    this.week = {
      0: '8uRdZ',
      1: 'lsCZk',
      2: 'XJKTk',
      3: 'qchG5',
      4: 'CQpzD',
      5: '89dm1',
      6: 'X7QiP',
    };

    this.months = {
      1: 'B84Pa',
      2: 'bABa9',
      3: '1M3Uh',
      4: 'iM9x2',
      5: 'tcOq1',
      6: 'QRiOI',
      7: 'f9a21',
      8: 'XoIWo',
      9: 'NFXDf',
      10: 'ADcab',
      11: 'Sn4oq',
      12: 'J5mJC',
    };
  }

  public endpoint(): string {
    const today: Date = new Date();

    return `${this.week[today.getDay()]}.${this.days[today.getDate()]}.${
      this.months[today.getMonth() + 1]
    }`;
  }
}
